export const partners = [
  "LP2M UIN Gusdur Pekalongan",
  "Kelurahan Kedungwuni Barat",
  "Masjid Baitussalam",
  "TPQ Al-Ikhlas",
  "SDN 01 Kedungwuni Barat",
  "Bank Sampah Berkah",
  "Karang Taruna KWB",
  "PKK Kelurahan KWB",
];
